import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login'
import Index from '@/pages/index'
import Recharge from '@/pages/recharge'
import Bind from '@/pages/bind'
import UseInfo from '@/pages/useinfo'
import Updata from '@/pages/updata'
import HistoryList from '@/pages/historyList'
import Forget from '@/pages/forget'
import Regist from '@/pages/regist'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index
    },{
      path: '/index',
      name: 'index',
      component: Index
    },{
      path: '/login',
      name: 'login',
      component: Login
    },{
      path: '/bind',
      name: 'bind',
      component: Bind
    },{
      path: '/recharge',
      name: 'recharge',
      component: Recharge
    },{
      path: '/useinfo',
      name: 'useinfo',
      component: UseInfo
    },{
      path: '/updata',
      name: 'updata',
      component: Updata
    },{
      path: '/historylist',
      name: 'historylist',
      component: HistoryList
    },{
      path: '/forget',
      name: 'forget',
      component: Forget
    },{
      path: '/regist',
      name: 'regist',
      component: Regist
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js